$(document).ready(function () {
  $(".module-style__fullsize-teaser-with-yellow-background.Text_Link_TextImageLeft .module-content-block .row.hidden-xs .col-sm-6:last-child").each(function() {
    $(this).children().wrapAll("<div class='fullsize-teaser-with-yellow-content-wrapper fullsize-teaser-content'></div>");
  });

  $(".module-style__fullsize-teaser-with-yellow-background.Text_Link_TextImageRight .module-content-block .row.hidden-xs .col-sm-6:first-child").each(function() {
    $(this).children().wrapAll("<div class='fullsize-teaser-with-yellow-content-wrapper fullsize-teaser-content'></div>");
  });

  $(".module-style__fullsize-teaser-with-violet-background.Text_Link_TextImageLeft .module-content-block .row.hidden-xs .col-sm-6:last-child").each(function() {
    $(this).children().wrapAll("<div class='fullsize-teaser-with-violet-content-wrapper fullsize-teaser-content'></div>");
  });

  $(".module-style__fullsize-teaser-with-violet-background.Text_Link_TextImageRight .module-content-block .row.hidden-xs .col-sm-6:first-child").each(function() {
    $(this).children().wrapAll("<div class='fullsize-teaser-with-violet-content-wrapper fullsize-teaser-content'></div>");
  });

  $(".module-style__fullsize-teaser-with-mint-background.Text_Link_TextImageLeft .module-content-block .row.hidden-xs .col-sm-6:last-child").each(function() {
    $(this).children().wrapAll("<div class='fullsize-teaser-with-mint-content-wrapper fullsize-teaser-content'></div>");
  });

  $(".module-style__fullsize-teaser-with-mint-background.Text_Link_TextImageRight .module-content-block .row.hidden-xs .col-sm-6:first-child").each(function() {
    $(this).children().wrapAll("<div class='fullsize-teaser-with-mint-content-wrapper fullsize-teaser-content'></div>");
  });
});

nc_initImagesViewportAnimation('.module-style__fullsize-teaser-animation', '80%');

function nc_initImagesViewportAnimation(selector, animationOffset) {
  $(document).ready(function () {
    $(selector).find('.module-content-block').each(function () {
      $(this).waypoint(function () {
          $(this.element).addClass('animated');
        },
        {offset: animationOffset});
    });
  });
}

$(function () {
  $('.slider-toggle-icon').on('click', function (e) {
    $('.header-slideIn').addClass('is-active');
    $('.slider-toggle-icon').addClass('is-active');
    e.stopPropagation()
  });
  $(document).on('click', function (e) {
    if ($(e.target).is('.header-slideIn, .header-slideIn *') === false) {
      $('.header-slideIn').removeClass('is-active');
      $('.slider-toggle-icon').removeClass('is-active');
    }
  });
  $('.header-slideIn-closebutton').on('click', function(){
    $('.header-slideIn').removeClass('is-active');
    $('.slider-toggle-icon').removeClass('is-active');
  });
});

$(window).load(function () {
  $(".header-slideIn").addClass("active-module");
});